import { CSSProperties } from 'react';
import { Toast, ToastBar as DefaultToastBar } from 'react-hot-toast';

export interface ToastBarProps {
  toast: Toast;
}

export function ToastBar({ toast }: ToastBarProps) {
  const style: CSSProperties = {
    ...toast.style,
    fontFamily:
      'Roboto, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  };
  return <DefaultToastBar toast={toast} style={style} />;
}

export default ToastBar;
